import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["initial", "enter"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full lg:w-3/5 lg:mt-8" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold" }, "Sobre"),
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-8 sm:text-justify font-[500]" }, [
    /*#__PURE__*/_createTextVNode(" O sistema Homero é uma plataforma de educação adaptativa que utiliza recursos de inteligência artificial para permitir que os alunos tenham uma experiência de aprendizado compatível com sua disponibilidade e condições de aprendizado. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Iniciativa do Ministério da Ciência, Tecnologia e Inovações e Softex no âmbito do Programa MCTI FUTURO. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Projeto apoiado pelo Ministério da Ciência, Tecnologia e Inovações, com recursos da Lei nº 8.248, de 23 de outubro de 1991. ")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_motion = _resolveDirective("motion")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "about p-8 flex justify-center items-center",
    initial: _ctx.initialMotion,
    enter: _ctx.enterMotion
  }, _hoisted_3, 8, _hoisted_1)), [
    [_directive_motion]
  ])
}